"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenSwaggerMetadata = void 0;
exports.loginSwaggerMetadata = loginSwaggerMetadata;
exports.getUserDetailsSwaggerMetadata = getUserDetailsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
function loginSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "User Login",
        description: "Validates user credentials and returns access and refresh tokens.",
    }), (0, swagger_1.ApiBody)({
        description: "User login credentials",
        schema: {
            type: "object",
            properties: {
                userName: { type: "string", example: "john_doe" },
                password: { type: "string", example: "password123" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Login successful",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.userLoggedIn },
                data: {
                    type: "object",
                    properties: {
                        accessToken: {
                            type: "object",
                            properties: {
                                accessToken: {
                                    type: "string",
                                    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
                                },
                                refreshToken: {
                                    type: "string",
                                    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Invalid credentials",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Invalid Credentials" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "User not found",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.userNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "An unexpected error occurred" },
            },
        },
    }));
}
function getUserDetailsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get User Details",
        description: "Retrieves user details by user ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.userDetailsRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.userDetailsRetrieved,
                },
                data: {
                    type: "object",
                    properties: {
                        userId: { type: "number", example: 1 },
                        salutation: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 1 },
                                lookUpValue: { type: "string", example: "Mr." },
                            },
                        },
                        firstName: { type: "string", example: "John" },
                        lastName: { type: "string", example: "Doe" },
                        emailId: { type: "string", example: "example@gmail.com" },
                        mobile: { type: "string", example: "1234567890" },
                        loginName: { type: "string", example: "johndoe" },
                        roles: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1 },
                                    name: { type: "string", example: "Admin" },
                                    description: { type: "string", example: "Administrator" },
                                },
                            },
                        },
                        country: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 1 },
                                name: { type: "string", example: "India" },
                                isoCode: { type: "string", example: null },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.userNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.userNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad request",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: messages_1.errorMessages.failedToFindUser },
            },
        },
    }));
}
const refreshTokenSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Refresh Access Token",
        description: "Validates the refresh token and generates a new access token.",
    }), (0, swagger_1.ApiBody)({
        description: "Refresh token to validate",
        schema: {
            type: "object",
            properties: {
                refreshToken: {
                    type: "string",
                    description: "The refresh token to validate.",
                    example: "your-refresh-token-here",
                },
            },
            required: ["refreshToken"],
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Access token refreshed successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Token refreshed successfully." },
                data: {
                    type: "object",
                    properties: {
                        accessToken: { type: "string", example: "new-access-token-here" },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Invalid or expired refresh token.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
};
exports.refreshTokenSwaggerMetadata = refreshTokenSwaggerMetadata;
